module.exports = __webpack_public_path__ + "media/swainsons-thrush-3.402f2678.mp3";